export default __webpack_public_path__ + "static/skills-tag-colored-dark-e05a62745da5870b4c68fa5d336cd35b266068fe4a4dc76225df463770a9cf4c.png";